import _ from 'lodash';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import { TASK_ATTRIBUTES_NEEDED } from '../../../HelperMethods/constants';
import { popView } from '../cardNavigationComponent/cardNavigationRedux';
import { upsertParentChildTasks } from '../../taskView/TaskViewPage/redux/reducer';

const getActionTypes = (reduxName) => (actions) => {
  const actionObject = {};
  actions.forEach((actionStr) => {
    actionObject[actionStr] = `${reduxName}_${actionStr}`;
  });
  return actionObject;
};

const types = getActionTypes('parentTaskCardRedux')(['SET_LOADER', 'SET_RELOAD']);

export function setLoader(loaderFlag) {
  return { type: types.SET_LOADER, loader: loaderFlag };
}

export function setReload(loaderFlag) {
  return { type: types.SET_RELOAD, reload: loaderFlag };
}

export function loadParentAndChildTasksOfParentTaskId(parentTaskId, childTasks, container) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setReload(false));
    try {
      const childTaskDict = _.keyBy(childTasks, 'id');
      const tasksObject = await ApiService.getChildTasksByParentTaskId(parentTaskId);
      if (tasksObject) {
        let tasksToBeUpdated = tasksObject.childTasks ?? [];

        tasksToBeUpdated = tasksToBeUpdated
          .filter((t) => !childTaskDict[t.id])
          .map((t) => {
            const task = _.pick(t, TASK_ATTRIBUTES_NEEDED);
            task.assignee = JSON.stringify(task.assignee || {});
            task.data = JSON.stringify(task.data || {});
            return task;
          });
        if (tasksObject.parentTask) {
          dispatch(upsertParentChildTasks([tasksObject.parentTask, ...tasksToBeUpdated, ...childTasks]));
        }
        return [...tasksToBeUpdated, ...childTasks];
      }
      throw new Error('Response not received from API');
    } catch (e) {
      logUtils.logError(e, 'Loading Parent Task Failed');
      dispatch(popView(container));
      return null;
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function confirmAllChildren(parentTaskId) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.confirmTasks(parentTaskId);
      if (response) {
        dispatch(setReload(true));
        return null;
      }
      throw new Error('Confirm all children not recieved from API');
    } catch (e) {
      logUtils.logError(e, 'Confirming all children Failed');
      return null;
    } finally {
      dispatch(setLoader(false));
    }
  };
}

const initialState = {
  loader: false,
  parentTask: null,
  childTasks: [],
  reload: false,
};

export default function parentTaskCardReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, loader: action.loader };
    }
    case types.SET_RELOAD: {
      return { ...state, reload: action.reload };
    }
    default: {
      return state;
    }
  }
}
